module.exports = __webpack_public_path__ + "img/apk.5dd55c92.png";